import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getBatchUserQueryConfig } from '../../hooks/react-query/useUserQuery';
import { useFieldLayout } from '../../hooks/useMedia';
import { techniciansUserFilter } from '../../modules/ComponentsLibrary/Pickers/newPickers/utils';
import { SpiffTool } from '../../modules/SpiffToolLogs/components/SpiffTool';
import { SpiffLogPhone } from '../../modules/SpiffToolLogs/phone/SpiffLogPhone';

export const Route = createFileRoute('/spiffLog/$spiffLogOwnerId')({
  component: RouteComponent,
  params: z.object({
    spiffLogOwnerId: z.coerce.number().min(1),
  }),
  // Phones and tablets open a spiff as a page: in the URL, so a refresh keeps it and the phone's
  // Back steps out. Desktop doesn't read it.
  validateSearch: z.object({
    spiff: z.coerce.number().int().positive().optional(),
  }),
  async loader(ctx) {
    const employees = await ctx.context.queryClient.ensureQueryData(
      getBatchUserQueryConfig(techniciansUserFilter),
    );
    const employee = employees?.results.find((el) => el.id === ctx.params.spiffLogOwnerId);
    if (!employee) {
      toast({
        variant: 'destructive',
        title: `Employee not found for spiff log (ID: ${ctx.params.spiffLogOwnerId})`,
      });
      throw redirect({ to: '/home' });
    }
    return { employee };
  },
  head(ctx) {
    return {
      meta: [
        {
          title: `Spiff Log - ${ctx.loaderData.employee.firstname} ${ctx.loaderData.employee.lastname}`,
        },
      ],
    };
  },
});

function RouteComponent() {
  const { spiffLogOwnerId } = Route.useParams();
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) {
    return <SpiffLogPhone ownerId={spiffLogOwnerId} />;
  }
  return <SpiffTool type="Spiff" ownerId={spiffLogOwnerId} />;
}
